<template>
  <hr :class="['divider', (vertical ? 'vertical' : 'horizontal')]"/>
</template>

<script>
export default {
  name: 'AppDivider',
  status: 'prototype',
  release: '1.0.0',
  props: {
    vertical: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.divider {
    display: inline-block;
    box-sizing: border-box;
    max-width: 100%;
    width: 100%;
    height: 1px;
    max-height: 1px;
    margin: 0;
    overflow: visible;
    border: 0;
    background: #b5b5b5;
    &.vertical {
      height: 100%;
      min-height: 100%;
      max-height: 100%;
      max-width: 1px;
      width: 1px;
    }
}
</style>
